// ====================================================================
// ziven-core forum ForgotPassword - v0.5.3 (Trello 卡 6a7fcee8778d13c624d2acdc)
// ====================================================================
//
// 覆盖 vendor ForgotPasswordModal 加手机号找回 tab 切换 (辉哥 11:51 拍板 go,
// 4 拍板全照 Coder 推荐). 实现方式: extend vendor ForgotPasswordModal.prototype
// (辉哥 2A 模式, 跟 v0.5.0/0.5.1/v0.5.2 同款), 不是 override. 维护成本低, vendor
// 升级兼容好.
//
// 跟 v0.5.0/0.5.1/v0.5.2 模式 100% 一致:
//   - vendor ForgotPasswordModal 走 lazy chunk load, 'flarum.reg.get()' 在未
//     load 时返回 undefined. 直接 extend 会 crash 'Cannot read properties of
//     undefined (reading prototype)'.
//   - 修法: 走 flarum.reg.onLoad 等 module 加载完再 extend (SOP 250).
//
// 设计 (4 拍板 11:51):
//   - 拍板 1 C1: extend vendor ForgotPasswordModal 加 2 主 tab (邮箱找回 / 手机号找回),
//     手机号 tab 内部 2 子 tab (验证码 / 旧密码), 单步 modal (跟 v0.5.2 SignUp 同款).
//   - 拍板 2 新开 2 routes: /reset-password-code + /reset-password-password
//     (跟 v0.5.2 register-code/register-password 解耦模式一致).
//   - 拍板 3 实现 2 模式 (验证码 + 旧密码, 跟登录/注册风格统一).
//   - 拍板 4 自动登录: 重置密码成功自动登录 (走 vendor SessionAuthenticator, reload 跳首页).
//
// 跟 v0.5.0/v0.5.1/v0.5.2 关键差异:
//   - PhoneLogin 改 vendor LogInModal (登录), SignUp 改 vendor SignUpModal (注册),
//     ForgotPassword 改 vendor ForgotPasswordModal (找回密码)
//   - vendor ForgotPasswordModal fields 是 email (50) + submit (-10)
//   - phone mode 时 items.remove('email'/'submit') (SOP 254 修法, 跟 v0.5.1.a 一致)
//   - vendor ForgotPasswordModal onsubmit 走 vendor /forgot (发邮件), 我们 phone
//     mode 拦截, 走 /api/ziven/core/phone/reset-password-code 或 /reset-password-password
//   - vendor ForgotPasswordModal 成功后 success = true 显示"邮件已发送", 我们 phone
//     mode 自动登录 + reload, 不走 vendor success 标志
//
// 10 Stream:
//   - phoneMode (false = 邮箱找回, true = 手机号找回)
//   - phoneSubMode (false = 验证码模式, true = 旧密码模式, 跟 v0.5.1/v0.5.2 同款)
//   - phoneNumber / phoneCode / phoneSending / phoneCountdown (验证码模式用)
//   - phoneOldPassword (旧密码模式用)
//   - phoneNewPassword (2 模式共用)
//   - phonePasswordSending / phonePasswordLockCountdown (复用 v0.5.1/v0.5.2 字段)
//
// 调用方: js/src/forum/index.js
// ====================================================================
import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Stream from 'flarum/common/utils/Stream';
import Button from 'flarum/common/components/Button';
// v0.5.3: 复用 v0.5.0/0.5.1/0.5.2 公共 helpers (sendSmsCode / startCountdown / clearTimers)
import { sendSmsCode, startCountdown, clearTimers } from '../utils/phoneAuthHelpers';
export default function forgotPasswordExtension() {
  // ForgotPasswordModal 在 vendor 是 lazy chunk 加载, 用 onLoad 等 module 加载完再 extend
  // 跟 v0.5.0/v0.5.1/v0.5.2 同款 pattern (SOP 250 沉淀)
  const flarumReg = typeof window !== 'undefined' && window.flarum && window.flarum.reg || typeof flarum !== 'undefined' && flarum.reg || null;
  if (!flarumReg) {
    console.warn('[ziven-core] forgotPasswordExtension: flarum.reg not available, skipped');
    return;
  }

  // 尝试立即拿 (可能已经同步注册)
  let ForgotPasswordModal = flarumReg.get('core', 'forum/components/ForgotPasswordModal');
  if (ForgotPasswordModal && ForgotPasswordModal.default) {
    ForgotPasswordModal = ForgotPasswordModal.default;
  }
  if (ForgotPasswordModal) {
    applyExtensions(ForgotPasswordModal);
  } else {
    // 模块未加载, 用 onLoad 等待
    flarumReg.onLoad('core', 'forum/components/ForgotPasswordModal', mod => {
      const cls = mod && mod.default ? mod.default : mod;
      if (cls) {
        applyExtensions(cls);
      } else {
        console.warn('[ziven-core] forgotPasswordExtension: ForgotPasswordModal module loaded but empty');
      }
    });
  }
}
function applyExtensions(ForgotPasswordModal) {
  if (!ForgotPasswordModal || !ForgotPasswordModal.prototype) {
    console.warn('[ziven-core] forgotPasswordExtension: ForgotPasswordModal has no prototype, skipped');
    return;
  }

  // ─────────────────────────────────────────────────────────────
  // oninit: 加 phone 模式状态 + phone 字段 Stream
  // ── v0.5.3 (Trello 卡 6a7fcee8778d13c624d2acdc, 辉哥 11:51 拍板) ──────────
  //   10 Stream (跟 v0.5.0/v0.5.1/v0.5.2 比):
  //   - phoneMode: false = 邮箱找回, true = 手机号找回
  //   - phoneSubMode: false = 验证码模式, true = 旧密码模式
  //   - phoneNumber / phoneCode / phoneSending / phoneCountdown: 验证码模式
  //   - phoneOldPassword: 旧密码模式 (新增, 跟 v0.5.2 SignUp 旧密码字段不同)
  //   - phoneNewPassword: 2 模式共用 (新增)
  //   - phonePasswordSending / phonePasswordLockCountdown: 复用 v0.5.1 字段 (密码模式防刷共用)
  //   vendor ForgotPasswordModal 没有 username Stream (不像 SignUp), 也不复用 vendor email
  //   Stream (phone mode 时 items.remove email, vendor email Stream 不用)
  // ─────────────────────────────────────────────────────────────
  extend(ForgotPasswordModal.prototype, 'oninit', function () {
    this.phoneMode = Stream(false);
    this.phoneSubMode = Stream(false);
    this.phoneNumber = Stream('');
    this.phoneCode = Stream('');
    this.phoneSending = Stream(false);
    this.phoneCountdown = Stream(0);
    this.phoneOldPassword = Stream('');
    this.phoneNewPassword = Stream('');
    this.phonePasswordSending = Stream(false);
    this.phonePasswordLockCountdown = Stream(0);
  });

  // ─────────────────────────────────────────────────────────────
  // fields: 加 phone tab 切换 + phone mode 字段
  // ── SOP 254 修法 (跟 v0.5.1.a 一致): phone mode 时 items.remove('email'/'submit')
  //   避免 vendor mithril vnode 引用缓存, wrap div hidden 实际从未渲染
  // ─────────────────────────────────────────────────────────────
  extend(ForgotPasswordModal.prototype, 'fields', function (items) {
    const phoneLoginEnabled = app.forum.attribute('zivenCorePhoneLoginEnabled');

    // 1. 顶部 tab 切换 UI (weight 100)
    if (phoneLoginEnabled) {
      items.add('phone-tab', m("div", {
        className: "Form-group ziven-core-forgot-tabs"
      }, m("button", {
        type: "button",
        className: 'ziven-core-forgot-tab ' + (!this.phoneMode() ? 'active' : ''),
        onclick: () => this.phoneMode(false)
      }, app.translator.trans('ziven-community-core.forum.forgot_password_tab_email')), m("button", {
        type: "button",
        className: 'ziven-core-forgot-tab ' + (this.phoneMode() ? 'active' : ''),
        onclick: () => this.phoneMode(true)
      }, app.translator.trans('ziven-community-core.forum.forgot_password_tab_phone'))), 100);
    }

    // 2. phone mode 时, 隐藏 vendor email/submit (SOP 254 修法)
    if (phoneLoginEnabled && this.phoneMode()) {
      const hideKeys = ['email', 'submit'];
      hideKeys.forEach(k => {
        if (items.has(k)) {
          items.remove(k);
        }
      });
    }

    // 3. phone mode: 子 tab (验证码 / 旧密码) + phone input + (code 或 oldPassword) + newPassword + confirmNewPassword + submit
    if (phoneLoginEnabled && this.phoneMode()) {
      const phoneLabel = app.translator.trans('ziven-community-core.forum.forgot_password_phone_placeholder');
      const codeLabel = app.translator.trans('ziven-community-core.forum.forgot_password_code_placeholder');
      const oldPasswordLabel = app.translator.trans('ziven-community-core.forum.forgot_password_old_password_placeholder');
      const newPasswordLabel = app.translator.trans('ziven-community-core.forum.forgot_password_new_password_placeholder');
      const confirmNewPasswordLabel = app.translator.trans('ziven-community-core.forum.forgot_password_confirm_new_password_placeholder');

      // 3.1 子 tab 切换 (验证码 / 旧密码) — weight 95
      items.add('phone-sub-tab', m("div", {
        className: "Form-group ziven-core-sub-tabs"
      }, m("button", {
        type: "button",
        className: 'ziven-core-sub-tab ' + (!this.phoneSubMode() ? 'active' : ''),
        onclick: () => this.phoneSubMode(false)
      }, app.translator.trans('ziven-community-core.forum.forgot_password_sub_tab_code')), m("button", {
        type: "button",
        className: 'ziven-core-sub-tab ' + (this.phoneSubMode() ? 'active' : ''),
        onclick: () => this.phoneSubMode(true)
      }, app.translator.trans('ziven-community-core.forum.forgot_password_sub_tab_password'))), 95);

      // 3.2 phone input (公共)
      items.add('phone-input', m("div", {
        className: "Form-group"
      }, m("input", {
        className: "FormControl",
        name: "phone",
        type: "tel",
        inputMode: "numeric",
        maxlength: "11",
        autocomplete: "tel",
        placeholder: phoneLabel,
        "aria-label": phoneLabel,
        bidi: this.phoneNumber,
        disabled: this.loading || this.phonePasswordLockCountdown() > 0
      })), 30);

      // 3.3 验证码模式: code input + 发送按钮
      if (!this.phoneSubMode()) {
        items.add('phone-code', m("div", {
          className: "Form-group ziven-core-phone-code-row"
        }, m("input", {
          className: "FormControl",
          name: "code",
          type: "text",
          inputMode: "numeric",
          maxlength: "6",
          autocomplete: "one-time-code",
          placeholder: codeLabel,
          "aria-label": codeLabel,
          bidi: this.phoneCode,
          disabled: this.loading
        }), m("button", {
          type: "button",
          className: "Button ziven-core-send-code-btn",
          disabled: this.loading || this.phoneSending() || this.phoneCountdown() > 0,
          onclick: this.sendSmsCode.bind(this)
        }, this.phoneCountdown() > 0 ? app.translator.trans('ziven-community-core.forum.login_resend_countdown', {
          seconds: this.phoneCountdown()
        }) : this.phoneSending() ? app.translator.trans('ziven-community-core.forum.login_sending') : app.translator.trans('ziven-community-core.forum.forgot_password_send_code'))), 15);
      }

      // 3.4 旧密码模式: old password input
      if (this.phoneSubMode()) {
        const lockSeconds = this.phonePasswordLockCountdown();
        items.add('phone-old-password', m("div", {
          className: "Form-group"
        }, m("input", {
          className: "FormControl ziven-core-password-input",
          name: "phone-old-password",
          type: "password",
          autocomplete: "current-password",
          minlength: "6",
          maxlength: "32",
          placeholder: lockSeconds > 0 ? app.translator.trans('ziven-community-core.forum.login_password_locked', {
            minutes: Math.ceil(lockSeconds / 60)
          }) : oldPasswordLabel,
          "aria-label": oldPasswordLabel,
          bidi: this.phoneOldPassword,
          disabled: this.loading || lockSeconds > 0
        })), 15);
      }

      // 3.5 new password input (2 模式共用, weight 10)
      items.add('phone-new-password', m("div", {
        className: "Form-group"
      }, m("input", {
        className: "FormControl ziven-core-password-input",
        name: "phone-new-password",
        type: "password",
        autocomplete: "new-password",
        minlength: "8",
        maxlength: "32",
        placeholder: newPasswordLabel,
        "aria-label": newPasswordLabel,
        bidi: this.phoneNewPassword,
        disabled: this.loading || this.phoneSubMode() && this.phonePasswordLockCountdown() > 0
      })), 10);

      // 3.6 confirm new password input (2 模式共用, weight 5)
      //    客户端 confirm 校验, 不一致返 alert
      items.add('phone-confirm-new-password', m("div", {
        className: "Form-group"
      }, m("input", {
        className: "FormControl ziven-core-password-input",
        name: "phone-confirm-new-password",
        type: "password",
        autocomplete: "new-password",
        minlength: "8",
        maxlength: "32",
        placeholder: confirmNewPasswordLabel,
        "aria-label": confirmNewPasswordLabel,
        bidi: this.phoneConfirmNewPassword || (this.phoneConfirmNewPassword = Stream('')),
        disabled: this.loading || this.phoneSubMode() && this.phonePasswordLockCountdown() > 0
      })), 5);

      // 3.7 submit button (走我们的 phoneResetCode / phoneResetPassword)
      items.add('phone-submit', m("div", {
        className: "Form-group"
      }, m(Button, {
        className: "Button Button--primary Button--block",
        type: "submit",
        loading: this.loading || this.phonePasswordSending(),
        disabled: this.phoneSubMode() && this.phonePasswordLockCountdown() > 0,
        onclick: this.phoneSubMode() ? this.phoneResetPassword.bind(this) : this.phoneResetCode.bind(this)
      }, this.phoneSubMode() ? app.translator.trans('ziven-community-core.forum.forgot_password_with_phone_old_password') : app.translator.trans('ziven-community-core.forum.forgot_password_with_phone_code'))), -10);
    }
  });

  // ─────────────────────────────────────────────────────────────
  // onsubmit: phone mode 拦截, 走 phoneResetCode / phoneResetPassword
  // ── 跟 v0.5.0/v0.5.1/v0.5.2 同款: override 而非 extend (SOP 253 签名错位)
  // ─────────────────────────────────────────────────────────────
  override(ForgotPasswordModal.prototype, 'onsubmit', function (original, e) {
    if (this.phoneMode && this.phoneMode()) {
      if (e && e.preventDefault) e.preventDefault();
      if (this.phoneSubMode && this.phoneSubMode()) {
        this.phoneResetPassword();
      } else {
        this.phoneResetCode();
      }
      return;
    }
    return original(e);
  });

  // ─────────────────────────────────────────────────────────────
  // onremove: 清掉倒计时 timer 避免内存泄漏 (跟 v0.5.0/0.5.1/v0.5.2 同款)
  // ── v0.5.3: 复用 clearTimers helper (跟 PhoneLogin.js / SignUp.js 同款)
  // ─────────────────────────────────────────────────────────────
  extend(ForgotPasswordModal.prototype, 'onremove', function () {
    clearTimers(this);
  });

  // ─────────────────────────────────────────────────────────────
  // 发送验证码 — POST /api/ziven/core/phone/send-code
  // ── v0.5.3: 复用 sendSmsCode helper (js/src/forum/utils/phoneAuthHelpers.js)
  //   helper 内部已经读 modal.phoneNumber(), 直接复用 100% OK
  // ─────────────────────────────────────────────────────────────
  ForgotPasswordModal.prototype.sendSmsCode = function () {
    sendSmsCode(this);
  };

  // ─────────────────────────────────────────────────────────────
  // 倒计时 (60s 防止连点) — v0.5.3 复用 startCountdown helper
  // ─────────────────────────────────────────────────────────────
  ForgotPasswordModal.prototype.startCountdown = function () {
    startCountdown(this);
  };

  // ─────────────────────────────────────────────────────────────
  // 客户端校验: confirm new password 跟 new password 一致
  // ── 2 模式共用, 不一致返 alert (跟 v0.5.0/v0.5.1 错误处理风格一致)
  // ─────────────────────────────────────────────────────────────
  ForgotPasswordModal.prototype.validateNewPasswords = function () {
    const newPwd = this.phoneNewPassword() || '';
    const confirmPwd = this.phoneConfirmNewPassword && this.phoneConfirmNewPassword() || '';
    if (newPwd !== confirmPwd) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.forgot_password_error_password_mismatch'));
      return false;
    }
    return true;
  };

  // ─────────────────────────────────────────────────────────────
  // 手机号 + 验证码重置密码 — POST /api/ziven/core/phone/reset-password-code
  // ── v0.5.3 4 拍板 4B: 重置成功自动登录 (走 vendor SessionAuthenticator, reload 跳首页)
  // ─────────────────────────────────────────────────────────────
  ForgotPasswordModal.prototype.phoneResetCode = function () {
    const phone = (this.phoneNumber() || '').trim();
    const code = (this.phoneCode() || '').trim();
    const newPassword = this.phoneNewPassword() || '';

    // 前端基本校验
    if (!/^1[3-9]\d{9}$/.test(phone)) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.forgot_password_error_invalid_phone'));
      return;
    }
    if (!/^\d{6}$/.test(code)) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.forgot_password_error_invalid_code'));
      return;
    }
    if (newPassword.length < 8 || newPassword.length > 32) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.forgot_password_error_password_too_short'));
      return;
    }
    if (!this.validateNewPasswords()) {
      return;
    }
    this.loading = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/ziven/core/phone/reset-password-code',
      body: {
        phone,
        code,
        newPassword
      },
      errorHandler: err => {
        this.loading = false;
        m.redraw();
        const code = err && err.status;
        if (code === 401) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.forgot_password_error_code_invalid'));
        } else if (code === 404) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.forgot_password_error_user_not_found'));
        } else if (code === 429) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.login_error_rate_limited'));
        } else if (code === 403) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.login_error_disabled'));
        } else if (code === 400) {
          const msg = err && err.alert && err.alert.content || app.translator.trans('ziven-community-core.forum.forgot_password_error_invalid_password');
          app.alerts.show({
            type: 'error'
          }, msg);
        } else {
          const msg = err && err.alert && err.alert.content || app.translator.trans('ziven-community-core.forum.forgot_password_error_failed');
          app.alerts.show({
            type: 'error'
          }, msg);
        }
      }
    }).then(response => {
      if (response && response.success && response.data) {
        // 服务端 session 已落, reload 走 Flarum session
        window.location.reload();
      }
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  };

  // ─────────────────────────────────────────────────────────────
  // 手机号 + 旧密码重置密码 — POST /api/ziven/core/phone/reset-password-password
  // ── 跟 phonePasswordLogin (v0.5.1) + phoneResetCode (v0.5.3) 同款 pattern
  // ── 复用 PhonePasswordAttempt 防刷 (后端用, 前端只处理 lockRemaining 倒计时)
  // ── 注: v0.5.3 不调 startPasswordLockCountdown helper (找回密码场景是 1 次提交, 没有
  //   "继续尝试" 循环), 后端 423 错误时显示错误即可, 不需要前端倒计时
  //   (简化: 跟 v0.5.1 Login 区分, 找密场景的 lock 是一次性错误, 不在 modal 倒计时解锁)
  // ─────────────────────────────────────────────────────────────
  ForgotPasswordModal.prototype.phoneResetPassword = function () {
    const phone = (this.phoneNumber() || '').trim();
    const oldPassword = this.phoneOldPassword() || '';
    const newPassword = this.phoneNewPassword() || '';

    // 前端基本校验
    if (!/^1[3-9]\d{9}$/.test(phone)) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.forgot_password_error_invalid_phone'));
      return;
    }
    if (oldPassword.length < 6 || oldPassword.length > 32) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.forgot_password_error_invalid_old_password'));
      return;
    }
    if (newPassword.length < 8 || newPassword.length > 32) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('ziven-community-core.forum.forgot_password_error_password_too_short'));
      return;
    }
    if (!this.validateNewPasswords()) {
      return;
    }
    this.loading = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/ziven/core/phone/reset-password-password',
      body: {
        phone,
        oldPassword,
        newPassword
      },
      errorHandler: err => {
        this.loading = false;
        m.redraw();
        const code = err && err.status;
        if (code === 401) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.forgot_password_error_invalid_credentials'));
        } else if (code === 423) {
          // 锁定: 复用 v0.5.1 lock 文案 (跟 v0.5.1 LoginWithPhonePassword 一致)
          const lockRemaining = err && err.alert && err.alert.content && err.alert.content.lockRemaining || 600;
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.login_error_locked', {
            minutes: Math.ceil(lockRemaining / 60)
          }));
        } else if (code === 429) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.login_error_rate_limited'));
        } else if (code === 403) {
          app.alerts.show({
            type: 'error'
          }, app.translator.trans('ziven-community-core.forum.login_error_disabled'));
        } else if (code === 400) {
          const msg = err && err.alert && err.alert.content || app.translator.trans('ziven-community-core.forum.forgot_password_error_invalid_password');
          app.alerts.show({
            type: 'error'
          }, msg);
        } else {
          const msg = err && err.alert && err.alert.content || app.translator.trans('ziven-community-core.forum.forgot_password_error_failed');
          app.alerts.show({
            type: 'error'
          }, msg);
        }
      }
    }).then(response => {
      if (response && response.success && response.data) {
        // 服务端 session 已落, reload 走 Flarum session
        window.location.reload();
      }
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  };
}
flarum.reg.add('ziiven-ziven-core', 'forum/components/ForgotPassword', forgotPasswordExtension);